import { render, staticRenderFns } from "./TicaoList.vue?vue&type=template&id=1fb13a76&scoped=true"
import script from "./TicaoList.vue?vue&type=script&lang=js"
export * from "./TicaoList.vue?vue&type=script&lang=js"
import style0 from "./TicaoList.vue?vue&type=style&index=0&id=1fb13a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb13a76",
  null
  
)

export default component.exports